import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnChanges,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  ContactCard,
  TextBtnCard,
} from '../../../shared/interfaces/card.interface';
import LinkType from '../../../shared/enums/link-type.enums';
import {
  Link,
  socialMediaLinks,
} from '../../../shared/interfaces/link.interface';
import { LinkComponent } from '../../atoms/link/link.component';
import CardType from '../../../shared/enums/card-type.eums';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Sizes, Colors } from '../../../shared/enums/shared.enums';
import {
  CaasFooter,
  CaasFormField,
  CaasInternalLink,
  CaasSimpleField,
  CaasSocialMediaItem,
} from '../../../shared/interfaces/caas/caas.interface';
import { HrefType } from '../../../shared/enums/href-type.enums';
import { CaasRoutesService } from '../../../services/caas-routes.service';
import { Router } from '@angular/router';
import { CapitalizePipe } from '../../capitalize.pipe';
import { CaasBodytextService } from '../../../services/caas-bodytext.service';
import { ErrorHandlerService } from '../../../services/error-handler.service';
import { safeAssign } from '../../../shared/utils/safe-assign.util';
import { FooterLoaderComponent } from './footer-loader/footer-loader.component';

@Component({
  selector: 'hdi-footer',
  standalone: true,
  imports: [
    CommonModule,
    LinkComponent,
    IconComponent,
    CapitalizePipe,
    FooterLoaderComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnChanges {
  @Input() caasData?: CaasFooter;
  // 642706 footer-delete-first-row
  // @Input() headline1? = '';
  // @Input() headline2? = '';
  //  @Input() headline3? = '';
  //  @Input() headline4? = '';
  @Input() cards: ContactCard[] = [];
  @Input() links: Link[] = [];
  @Input() textBtnCards: TextBtnCard[] = [];
  @Input() socialLinks: socialMediaLinks[] = [];
  @Input() legalLinks: Link[] = [];

  // Enums and constants
  CardType = CardType;
  HrefType = HrefType;
  LinkType = LinkType;
  Sizes = Sizes;
  Colors = Colors;
  TextColors = Colors;

  public isLoading = true;

  constructor(
    public readonly cdr: ChangeDetectorRef,
    private readonly caasRoutesService: CaasRoutesService,
    private readonly router: Router,
    private readonly caasBodytextService: CaasBodytextService,
    private readonly errorHandler: ErrorHandlerService,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['caasData']?.currentValue &&
      this.caasData &&
      Object.keys(this.caasData || {}).length
    ) {
      this.setCaasContent();
      if (isPlatformBrowser(this.platformId)) {
        this.isLoading = false;
      }
      this.cdr.detectChanges();
    }
  }

  // Method to handle setting content for footer
  private setCaasContent(): void {
    if (!this.caasData) return;

    // Contact Cards setup
    // 642706 footer-delete-first-row
    // this.setContactCards();

    // Link configurations for company, help, newsletter, and social media links
    // 642706 footer-delete-first-row
    const linkConfigurations = [
      /*      { key: 'gc_company_links', method: this.setLinksList.bind(this) },
      { key: 'gc_help_link', method: this.setHelpLinks.bind(this) },
      { key: 'gc_newsletter_link', method: this.setNewsletterLinks.bind(this) },*/
      { key: 'gc_social_media_list', method: this.setSocialLinks.bind(this) },
    ];

    // Dynamically setting the content for each link type if data exists
    linkConfigurations.forEach(({ key, method }) => {
      if (this.caasData ? this.caasData[key]?.value : false) {
        method();
      } else {
        console.warn(
          `FooterComponent > linkConfigurations > No data found for: ${key}`
        );
      }
    });

    // Setting legal links (Impressum and Datenschutz)
    this.setImprintLinks();
    this.setLegacyPolicyLinks();
  }

  // contact cards
  // 642706 footer-delete-first-row
  /*  private setContactCards(): void {
    this.addPhoneContactCard();
    this.addContactFormCard(
      'envelope',
      'gc_contact_form_headline',
      'gc_contact_form_internal_link',
      'gc_contact_form_description'
    );
    this.addContactFormCard(
      'message-exclamation',
      'gc_contact_form_schaden_headline',
      'gc_contact_form_schaden_internal_link',
      'gc_contact_form_schaden_description'
    );
  }*/

  /*  getTelephoneLink(phone: string): string {
    return RegExp(/^\+?[0-9\s\-().]*$/).exec(phone) ? `tel:${phone}` : '';
  }

  // Add phone contact card
  private addPhoneContactCard(): void {
    let phoneHeader;
    let textLink = '';
    let link;
    let date;
    safeAssign(
      () => {
        phoneHeader = this.caasData?.gc_telephone_header?.value;
      },
      'Set phoneHeader',
      this.errorHandler
    );
    safeAssign(
      () => {
        textLink =
          this.caasData?.gc_telephone_link?.value?.formData?.lt_text?.value ||
          '';
      },
      'Set textLink',
      this.errorHandler
    );
    safeAssign(
      () => {
        link = this.getTelephoneLink(
          this.caasData?.gc_telephone_link?.value?.formData?.lt_telephone
            ?.value || ''
        );
      },
      'Set link',
      this.errorHandler
    );
    safeAssign(
      () => {
        date = this.caasData?.gc_telephone_subheader?.value?.toString() || '';
      },
      'Set date',
      this.errorHandler
    );
    if (phoneHeader && !this.cards.some((card) => card.icon === 'phone')) {
      const phoneCard: ContactCard = {
        icon: 'phone',
        title: phoneHeader,
        textLink,
        link,
        linkType: LinkType.INLINE_LIGHT,
        date,
        disabled: false,
        iconColor: Colors.BLACK,
        linkTarget: '_self',
      };
      this.cards.push(phoneCard);
    }
  }*/

  // Add a general contact form card
  /*  private addContactFormCard(
    icon: string,
    headlineKey: string,
    linkKey: string,
    descriptionKey: string
  ): void {
    if (
      this.caasData?.[headlineKey]?.value &&
      !this.cards.some((card) => card.icon === icon)
    ) {
      let title = '';
      let textLink = '';
      let link;
      let subtitle;
      safeAssign(
        () => {
          title = this.caasData?.[headlineKey]?.value?.toString() || '';
        },
        'Set title',
        this.errorHandler
      );
      safeAssign(
        () => {
          textLink =
            this.caasData?.[
              linkKey
            ]?.value?.formData?.lt_link_label?.value?.toString() || '';
        },
        'Set textLink',
        this.errorHandler
      );
      safeAssign(
        () => {
          link =
            this.caasRoutesService.getSeoRouteByIdentifier(
              this.caasData?.[linkKey]?.value?.formData?.lt_link_internal?.value
                ?.identifier ?? '',
              this.router.config
            )?.path ?? '';
        },
        'Set link',
        this.errorHandler
      );
      safeAssign(
        () => {
          subtitle = this.caasData?.[descriptionKey]?.value?.toString() || '';
        },
        'Set subtitle',
        this.errorHandler
      );
      const newCard: ContactCard = {
        icon,
        title,
        textLink,
        link,
        subtitle,
        disabled: false,
        iconColor: Colors.BLACK,
        linkType: LinkType.PRIMARY_ARROW,
        linkTarget: '_self',
      };
      this.cards.push(newCard);
    }
  }*/

  // Process the link data and return formatted Link object
  private processLinkData(linkData: {
    lt_link_label: CaasSimpleField;
    lt_link_external: CaasSimpleField;
    lt_link_internal: CaasInternalLink;
    lt_link_title: CaasSimpleField;
    lt_link_type: CaasFormField;
    lt_link_vimeo_id: CaasSimpleField;
    st_anchor_name: CaasSimpleField;
  }): Link {
    const isExternal = linkData?.lt_link_type?.value?.identifier === 'external';

    const linkType = isExternal ? LinkType.EXTERNAL : LinkType.PRIMARY_ARROW;
    const href = isExternal
      ? (linkData?.lt_link_external?.value?.toString() ?? '')
      : (this.caasRoutesService.getSeoRouteByIdentifier(
          linkData?.lt_link_internal?.value?.identifier ?? '',
          this.router.config
        )?.path ?? '404');
    return {
      label: linkData?.lt_link_label?.value?.toString() ?? '',
      href,
      hrefType: isExternal ? HrefType.EXTERNAL : HrefType.ANGULAR_ROUTE,
      target: isExternal ? '_blank' : '_self',
      linkType,
    };
  }

  // Set links for the company section
  // 642706 footer-delete-first-row
  /*  setLinksList(): void {
    safeAssign(
      () => {
        this.headline2 =
          this.caasData?.gc_company_header?.value || 'Default Headline';
      },
      'Set headline2',
      this.errorHandler
    );

    let companyLinks: CaasCompanyLink[] = [];

    if (this.caasData?.gc_company_links?.value) {
      safeAssign(
        () => {
          companyLinks = this.caasData?.gc_company_links?.value ?? [];
        },
        'Set companyLinks',
        this.errorHandler
      );
    }
    this.links = companyLinks
      ? companyLinks.map((link) => this.processLinkData(link?.formData))
      : [];
  }*/

  // Set imprint and privacy links
  private setLegalLinks(key: string, fallbackLabel: string): Link[] {
    const data = this.caasData?.[key]?.value?.formData;
    if (!data) {
      console.warn(
        `FooterComponent > setLegalLinks: No valid ${key} data found.`
      );
      return [{ label: fallbackLabel, href: '' }];
    }
    return [
      {
        label: data.lt_link_label?.value || fallbackLabel,
        href:
          this.caasRoutesService.getSeoRouteByIdentifier(
            data.lt_link_internal?.value?.identifier ?? '',
            this.router.config
          )?.path ?? '404',
      },
    ];
  }

  setImprintLinks(): void {
    this.legalLinks = this.setLegalLinks('gc_imprint', 'Impressum');
  }

  setLegacyPolicyLinks(): void {
    this.legalLinks = [
      ...this.legalLinks,
      ...this.setLegalLinks('gc_privacy', 'Datenschutz'),
    ];
  }

  // Set help links and text button cards
  // 642706 footer-delete-first-row
  /*  setHelpLinks(): void {
    let helpData: CaasLinkFormData | null = null;
    safeAssign(
      () => {
        helpData = this.caasData?.gc_help_link?.value?.formData ?? null;
      },
      'Set helpData',
      this.errorHandler
    );

    if (!helpData) {
      console.warn('No help data found.');
      return;
    }
    let hrefType: HrefType = HrefType.ANGULAR_ROUTE;
    let subtitle: string = '';
    let btnLabel: string = '';
    let btnHref: string = '';
    let linkTitle: string = '';
    let linkRel: string = '';
    let btnHeadline: string = '';

    safeAssign(
      () => {
        this.headline3 =
          this.caasData?.gc_help_headline?.value?.toString() ?? '';
      },
      'Set headline3',
      this.errorHandler
    );
    safeAssign(
      () => {
        hrefType = this.caasData?.gc_help_link
          ? this.caasBodytextService.getHrefType(this.caasData?.gc_help_link)
          : HrefType.ANGULAR_ROUTE;
      },
      'Set hrefType',
      this.errorHandler
    );
    safeAssign(
      () => {
        subtitle = this.caasData?.gc_help_description?.value?.toString() ?? '';
      },
      'Set subtitle',
      this.errorHandler
    );
    safeAssign(
      () => {
        btnLabel = helpData?.lt_link_label?.value?.toString() ?? '';
      },
      'Set btnLabel',
      this.errorHandler
    );
    safeAssign(
      () => {
        btnHref = this.caasData?.gc_help_link
          ? this.caasBodytextService.getHref(this.caasData?.gc_help_link)
          : '';
      },
      'Set btnHref',
      this.errorHandler
    );
    safeAssign(
      () => {
        linkTitle = helpData?.lt_link_title.value ?? '';
      },
      'Set linkTitle',
      this.errorHandler
    );
    safeAssign(
      () => {
        linkRel = helpData?.lt_link_follow.value.identifier ?? '';
      },
      'Set linkRel',
      this.errorHandler
    );
    safeAssign(
      () => {
        btnHeadline =
          this.caasData?.gc_help_cta_headline?.value?.toString() ?? '';
      },
      'Set btnHeadline',
      this.errorHandler
    );

    this.textBtnCards.push({
      subtitle: subtitle ?? '',
      btnLabel: btnLabel,
      btnHrefType: hrefType,
      btnHref: btnHref ?? '',
      linkTitle: linkTitle,
      linkRel: linkRel,
      btnHeadline: btnHeadline,
    });
  }*/

  // Set newsletter links and text button cards
  /*
  setNewsletterLinks(): void {
    let newsletterData: CaasLinkFormData | null = null;
    let hrefType: HrefType = HrefType.ANGULAR_ROUTE;
    safeAssign(
      () => {
        this.headline4 =
          this.caasData?.gc_newsletter_headline?.value?.toString() ?? '';
      },
      'Set headline4',
      this.errorHandler
    );
    safeAssign(
      () => {
        hrefType = this.caasData?.gc_newsletter_link
          ? this.caasBodytextService.getHrefType(
              this.caasData?.gc_newsletter_link
            )
          : HrefType.ANGULAR_ROUTE;
      },
      'Set hrefType',
      this.errorHandler
    );
    safeAssign(
      () => {
        newsletterData =
          this.caasData?.gc_newsletter_link?.value?.formData ?? null;
      },
      'Set newsletterData',
      this.errorHandler
    );

    if (newsletterData) {
      let btnHeadline: string = '';
      let subtitle: string = '';
      let btnLabel: string = '';
      let btnHref: string = '';
      let linkTitle: string = '';
      let linkRel: string = '';
      safeAssign(
        () => {
          btnHeadline =
            this.caasData?.gc_newsletter_cta_headline?.value?.toString() ?? '';
        },
        'Set btnHeadline',
        this.errorHandler
      );
      safeAssign(
        () => {
          subtitle =
            this.caasData?.gc_newsletter_description?.value?.toString() ?? '';
        },
        'Set subtitle',
        this.errorHandler
      );
      if (newsletterData && 'lt_link_label' in newsletterData) {
        safeAssign(
          () => {
            btnLabel = newsletterData?.lt_link_label?.value?.toString() ?? '';
          },
          'Set btnLabel',
          this.errorHandler
        );
      }
      safeAssign(
        () => {
          btnHref = this.caasData?.gc_newsletter_link
            ? this.caasBodytextService.getHref(
                this.caasData?.gc_newsletter_link
              )
            : '';
        },
        'Set btnHref',
        this.errorHandler
      );
      safeAssign(
        () => {
          linkTitle =
            this.caasData?.gc_newsletter_link?.value?.formData?.lt_link_title
              .value ?? '';
        },
        'Set linkTitle',
        this.errorHandler
      );
      safeAssign(
        () => {
          linkRel =
            this.caasData?.gc_newsletter_link?.value?.formData?.lt_link_follow
              .value.identifier ?? '';
        },
        'Set linkRel',
        this.errorHandler
      );

      this.textBtnCards.push({
        btnHeadline: btnHeadline,
        subtitle: subtitle,
        btnLabel: btnLabel,
        btnHrefType: hrefType,
        btnHref: btnHref,
        btnTarget: '_blank',
        linkTitle: linkTitle,
        linkRel: linkRel,
      });
    }
  }
*/

  setSocialLinks() {
    let socialMediaList: CaasSocialMediaItem[] | undefined;
    safeAssign(
      () => {
        socialMediaList = this.caasData?.gc_social_media_list?.value;
      },
      'Set socialMediaList',
      this.errorHandler
    );

    if (!Array.isArray(socialMediaList) || !socialMediaList.length) {
      console.warn('FooterComponent -> No valid social media links found.');
      this.socialLinks = [];
      return;
    }

    if (
      socialMediaList &&
      Array.isArray(socialMediaList) &&
      socialMediaList.length
    ) {
      safeAssign(
        () => {
          this.socialLinks = (socialMediaList || []).map((link) => {
            let iconPrefix = 'fab';
            let icon;
            let identifier = '';
            let href = '';
            safeAssign(
              () => {
                identifier =
                  link.formData?.lt_icontype?.value?.identifier || '';
              },
              'Set identifier',
              this.errorHandler
            );
            safeAssign(
              () => {
                href = link.formData?.lt_link_external?.value || '';
              },
              'Set href',
              this.errorHandler
            );

            switch (identifier) {
              case 'facebook':
                icon = 'facebook-f';
                break;
              case 'linkedin':
                icon = 'linkedin-in';
                break;
              case 'custom':
                icon = 'globe';
                iconPrefix = 'fal';
                break;
              default:
                icon = identifier;
            }

            return {
              icon,
              href: href,
              iconPrefix,
            };
          });
        },
        'Set socialLinks',
        this.errorHandler
      );
      return;
    }
    return;
  }

  get hasInvalidLegalLinks(): boolean {
    return (
      Array.isArray(this.legalLinks) &&
      this.legalLinks.some((a) => a?.href === '')
    );
  }
}
